"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosVariantLocationUpdateInputSchema = exports.APosVariantLocationSchema = exports.APosB2BChannelConfigSchema = exports.APosChannelConfigSchema = exports.APosRetailLinkSchema = exports.APosRetailLinkFieldSchema = exports.APosRetailLinkPriceModeSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
const product_schema_1 = require("./product.schema");
// Online/B2B settings that FOLLOW Retail. Resolved from the same VL's `retail`
// config at read time (see resolveChannelConfig in channelFields.ts), so the
// channel tracks later Retail changes. `price` is ALSO materialized on write for
// legacy readers.
exports.APosRetailLinkPriceModeSchema = zod_1.z.enum(['match', 'plus_amount', 'minus_amount', 'plus_percent', 'minus_percent']);
exports.APosRetailLinkFieldSchema = zod_1.z.enum(['taxIds', 'feeIds', 'compliancePresetId', 'promotionId', 'commissionId', 'cashDiscountId']);
exports.APosRetailLinkSchema = zod_1.z.object({
    price: zod_1.z.object({ mode: exports.APosRetailLinkPriceModeSchema, value: zod_1.z.number().nonnegative() }).optional(),
    fields: zod_1.z.array(exports.APosRetailLinkFieldSchema).default([]),
});
// Per-channel config — price, rules, and availability for one sales channel at one location
exports.APosChannelConfigSchema = zod_1.z.object({
    enabled: zod_1.z.boolean().default(false),
    price: zod_1.z.number().nonnegative(),
    priceAuto: zod_1.z.boolean().default(true),
    taxIds: zod_1.z.array(zod_1.z.string()).default([]),
    feeIds: zod_1.z.array(zod_1.z.string()).default([]),
    compliancePresetId: zod_1.z.string().optional(),
    promotionId: zod_1.z.string().optional(),
    commissionId: zod_1.z.string().optional(),
    // Retail and Online (Online only when the store accepts cash on delivery) — never B2B.
    // See cash-discount.schema.ts
    cashDiscountId: zod_1.z.string().optional(),
    pricingModelId: zod_1.z.string().optional(),
    // Online/B2B only: settings that follow Retail. null/absent = not linked.
    retailLink: exports.APosRetailLinkSchema.nullable().optional(),
});
// B2B channel extends base with wholesale-specific fields
exports.APosB2BChannelConfigSchema = exports.APosChannelConfigSchema.extend({
    minOrderQty: zod_1.z.number().int().positive().default(1),
});
exports.APosVariantLocationSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    // Stock
    stockQuantity: zod_1.z.number().int().default(0),
    reorderPoint: zod_1.z.number().int().nonnegative().optional(),
    reorderQuantity: zod_1.z.number().int().positive().optional(),
    trackInventory: zod_1.z.boolean().nullable().default(null), // null = inherit variant → product
    // Per-channel configs
    retail: exports.APosChannelConfigSchema,
    online: exports.APosChannelConfigSchema,
    b2b: exports.APosB2BChannelConfigSchema,
    // Loyalty override (null = inherit variant → product)
    loyaltyConfig: product_schema_1.APosLoyaltyConfigSchema.nullable().optional(),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
// Input for updating a VariantLocation (all fields optional)
exports.APosVariantLocationUpdateInputSchema = zod_1.z.object({
    trackInventory: zod_1.z.boolean().nullable().optional(),
    reorderPoint: zod_1.z.number().int().nonnegative().optional(),
    reorderQuantity: zod_1.z.number().int().positive().optional(),
    retail: exports.APosChannelConfigSchema.partial().optional(),
    online: exports.APosChannelConfigSchema.partial().optional(),
    b2b: exports.APosB2BChannelConfigSchema.partial().optional(),
    loyaltyConfig: product_schema_1.APosLoyaltyConfigSchema.nullable().optional(),
});
//# sourceMappingURL=variant-location.schema.js.map